/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
import { Subscriber } from '../Subscriber';
export function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof Subscriber) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}
//# sourceMappingURL=canReportError.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/canReportError.js
// module id = 348
// module chunks = 2